if (!customElements.get('ratings-manuly')) {
    customElements.define(
        'ratings-manuly',
        class ProductInfoManuly extends HTMLElement {

            constructor() {
                super();
                this.ratings = this.querySelectorAll(".jdgm-rev__author");
                this.lbl = "";
                this.lbl += "Birgit, Peter und 200 anderen gefällt das";
                this.querySelector("#ratingDiv").innerHTML = this.lbl;
            }

        });
        }